import { API_CREATE_MAGAZINE_CMS, API_GET_IMAGE_FROM_BASE64, API_GET_MAGAZINE, API_GET_MAGAZINE_APPS, API_MAGAZINE_DETAIL_CMS, API_UPDATE_MULTIPLE_MAGAZINE } from 'configs/api'
import { paramsGet } from 'models/common'
import { IsSubscribeType, reqUpdateMuntipleMagazineType } from 'models/magazine'
import { bindParams } from 'utilities/helpers'
import networkAdapter from 'utilities/networkAdapter'

export const getMagazineApp = async () => {
  try {
    const dataMagazine = await networkAdapter.get(API_GET_MAGAZINE_APPS, {
      per_page: 300
    })
    return dataMagazine.data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine app', error)
  }
}

export const createMagazineApp = async (data: any) => {
  try {
    const dataMagazine = await networkAdapter.post(API_GET_MAGAZINE_APPS, data)
    return dataMagazine
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine app', error)
  }
}

interface paramsGetMagazine extends paramsGet {
  app_id: string
  is_subscribable?: IsSubscribeType
  category_id?:number
}

export const getMagazineApi = async (params: paramsGetMagazine) => {
  try {
    const dataMagazine = await networkAdapter.get(API_GET_MAGAZINE, params)
    return dataMagazine.data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine', error)
  }
}

export const createMagazineApi = async (req: any) => {
  try {
    const dataMagazine = await networkAdapter.post(API_CREATE_MAGAZINE_CMS, req)
    return dataMagazine
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('createMagazineApi', error)
  }
}

export const updateMagazineApi = async ( req: any, magazineId?: number) => {
  try {
    const dataMagazine = await networkAdapter.post(
      bindParams(API_MAGAZINE_DETAIL_CMS, {
        id: magazineId ? magazineId : ''
      }),
      req
    )
    return dataMagazine
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error get magazine', error)
  }
}

export const updateMuntipleMagazine = async (req: reqUpdateMuntipleMagazineType[]) => {
  try {
    const postApi = await networkAdapter.put(API_UPDATE_MULTIPLE_MAGAZINE, { magazines: req })
    return postApi
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error_updateMuntipleMagazine', error)
  }
}


export const getImageFromBase64 = async (base64Images: string[]) => {
  const dataImage = await networkAdapter.post(API_GET_IMAGE_FROM_BASE64, {
    images: base64Images
  })
  return dataImage.data
}